module.exports = __webpack_public_path__ + "static/media/dine-popup-icon.9c2115fa.png";